import InvoiceForm from './InvoiceForm';
import connect from './connector';

export default connect(InvoiceForm);
